'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BrowserDetection = function (_React$Component) {
  _inherits(BrowserDetection, _React$Component);

  function BrowserDetection(props) {
    _classCallCheck(this, BrowserDetection);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BrowserDetection).call(this, props));

    var isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && !!window.chrome.webstore;
    var isBlink = (isChrome || isOpera) && !!window.CSS;
    var browser = undefined;

    if (isOpera) {
      browser = 'opera';
    } else if (isFirefox) {
      browser = 'firefox';
    } else if (isSafari) {
      browser = 'safari';
    } else if (isIE) {
      browser = 'ie';
    } else if (isEdge) {
      browser = 'edge';
    } else if (isChrome) {
      browser = 'chrome';
    } else if (isBlink) {
      browser = 'blink';
    } else {
      browser = 'unknown';
    }

    _this.state = {
      browser: browser,
      children: _react2.default.createElement('div', null)
    };
    return _this;
  }

  _createClass(BrowserDetection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState(this.getConfigs.call(this));
    }
  }, {
    key: 'getConfigs',
    value: function getConfigs() {
      var children = this.props.children;
      var browser = this.state.browser;

      var func = children[browser] || children.default;
      return {
        browser: browser,
        children: func(browser)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return this.props.once ? this.state.children : function () {
        return _this2.getConfigs.call(_this2).children;
      }();
    }
  }]);

  return BrowserDetection;
}(_react2.default.Component);

BrowserDetection.defaultProps = {
  once: true
};

BrowserDetection.propTypes = {
  children: _react2.default.PropTypes.object.isRequired,
  once: _react2.default.PropTypes.bool
};

exports.default = BrowserDetection;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-browser-detection/lib/index.js
 ** module id = 255
 ** module chunks = 0
 **/